import React from "react";
import Header from "./Header";
import checkMark from "../assets/images/check-mark.png";
import "../assets/styles/CompleteJourneyScreenNew.css";

const CompleteJourneyScreenNew = () => {
  return (
    <div>
      <div className="confetti-container">
        {[...Array(50)].map((_, index) => (
          <div
            key={index}
            className="confetti"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              backgroundColor: [
                "#6366f1",
                "#8b5cf6",
                "#ec4899",
                "#f59e0b",
                "#10b981",
                "#3b82f6",
              ][Math.floor(Math.random() * 6)],
            }}
          />
        ))}
      </div>
      <Header />
      <div className="complete-screen-container">
        <div>
          <h2>Identity verification journey complete</h2>
          <p>Thank you for verifying your identity. </p>
          <div>
            <p>
              You can expect to receive an email with your result in less than 5
              minutes. However, if further review is needed. it may take 3-5
              business days to get your result.
            </p>
            <p>
              You can close this app, none of your data will be stored in this
              app or on your phone
            </p>
          </div>
        </div>
        <div className="verification-information-container">
          <div className="verification-information-contents">
            <img src={checkMark} />
            Document image taken
          </div>
          <hr style={{ justifySelf: "center" }} />
          <div className="verification-information-contents">
            <img src={checkMark} />
            Self photo take (selfie)
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteJourneyScreenNew;
